export default __webpack_public_path__ + "static/media/1004.643b9ac5.svg";